import {Component, inject} from '@angular/core';
import {rxResource} from "@angular/core/rxjs-interop";
import {MediaService, SlideService} from '@api-services'
import {map, switchMap} from "rxjs/operators";
import {ButtonComponent} from "@components";
import {SlideDto} from "@api-contracts";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'wun-slides',
  imports: [
    ButtonComponent,
    RouterLink,
  ],
  templateUrl: './slides.component.html',
  styleUrl: './slides.component.scss'
})
export class SlidesComponent {

  private readonly slidesService = inject(SlideService);
  private readonly mediaService = inject(MediaService);

  slides = rxResource({
    stream: () => {
      return this.slidesService.slidesFindAndPaginate({
        includes: '["images"]'
      }).pipe(map(d => d.data))
    },
  })

  deleteSlide(slide: SlideDto) {
    const _ = confirm('Attenzione l\'operazione é irreversibile');
    this.slidesService.slidesDelete({
      id: slide.id,
    }).pipe(switchMap(() => this.mediaService.mediaDelete({
      id: slide.images[0].id
    })))
      .subscribe(d => {
        this.slides.reload()
      })
  }
}
